// create a file object based on a metadata object
const createFileFromMetaData = (metadata) => ({
  name: metadata.name,
  type: metadata.contentType || metadata.type,
  size: metadata.size,
});

export default createFileFromMetaData;
